var map = {
	"./admin.png": "WJk/",
	"./credential_auditor.png": "LPwx",
	"./customer.png": "x8vm",
	"./kefu.png": "wj/y",
	"./seller.png": "Z3uP",
	"./switchboard.png": "bPj/"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "A3of";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/UserTypeEmoji ^\.\/.*\.png$
// module id = A3of
// module chunks = 0